// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"653":"4da94bef","804":"5b32e1f6","972":"9650b490"}[chunkId] + ".js";
};